import * as React from 'react';

import {
  Lang,

  scrollToId,

  Title,
  ContentContainer,
} from '@bluecurrent/web-component-lib';

import StepByStepItem from '../Modules/StepByStepItem';

export default function StepByStep() {
  const { _ } = Lang.useTranslation();

  const scrollDuration = 1500;

  const STEPS = [
    {
      id: 0,
      text: _('invest.fillOutTheForm', { ns: 'branding' }),
      icon: 'Edit',
      onPress: () => scrollToId({
        id: 'invest',
        duration: scrollDuration,
      }),
    },
    {
      id: 1,
      text: _('invest.youWillReceiveTheLoanAgreementViaDocuSign', { ns: 'branding' }),
      icon: 'FileInvoice',
    },
    {
      id: 2,
      text: _('invest.readThisCarefullyAndSignTheAgreement', { ns: 'branding' }),
      icon: 'FileSignature',
    },
    {
      id: 3,
      text: _('invest.completeThePaymentInstructions', { ns: 'branding' }),
      icon: 'MoneyCheckEdit',
    },
    {
      id: 4,
      text: _('invest.youCanExpectYourFirstInterestPaymentInJanuary2026', { ns: 'branding' }),
      icon: 'Check',
    },
  ];

  return (
    <div
      style={{
        marginTop: 100,
      }}
    >
      <ContentContainer>
        <Title
          fontSize="2.8em"
          textAlign="center"
        >
          {_('howDoesItWork', { ns: 'ui' })}
        </Title>
        <div
          style={{
            marginTop: 50,
            gap: 30,
            display: 'grid',
            gridAutoFlow: 'dense',
            gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
          }}
        >
          {
            STEPS.map((item) => (
              <StepByStepItem
                key={item.id}
                text={item.text}
                icon={item.icon}
                onPress={item.onPress}
              />
            ))
          }
        </div>
      </ContentContainer>
    </div>
  );
}
